import { VideoObject } from 'vopay';
import { useEffect, useState } from 'react';
import { SearchBar } from 'UI';
import styles from './VideoContainer.module.scss';

type VideoSearchFormProps = {
  videos: VideoObject[];
  filteredByKeyWordLists: { [key: string]: VideoObject };
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  setFilteredByKeyWordLists: (video: { [key: string]: VideoObject }) => void;
  getSelectedVideo: (video: VideoObject) => void;
  setHasSearchResult: (e: boolean) => void;
};

export default function VideoSearchForm({
  videos,
  filteredByKeyWordLists,
  searchTerm,
  setSearchTerm,
  setFilteredByKeyWordLists,
  getSelectedVideo,
  setHasSearchResult,
}: VideoSearchFormProps) {
  // The matches dropdown hides after a search or a pick, until the term changes again
  const [isMenuDismissed, setIsMenuDismissed] = useState(false);
  const isMenuVisible = !isMenuDismissed && Object.values(filteredByKeyWordLists || {}).length !== 0;

  useEffect(() => {
    setIsMenuDismissed(false);

    if (searchTerm === '') {
      setFilteredByKeyWordLists({});
    } else {
      const filtered = (videos || [])
        .filter((video) => video.title.toLowerCase().includes(searchTerm.toLowerCase()))
        .reduce(
          (accumulator, video, index) => ({
            ...accumulator,
            [index]: { ...video },
          }),
          {},
        );

      setFilteredByKeyWordLists(filtered);
    }
  }, [searchTerm]);

  useEffect(() => {
    if (searchTerm === '') {
      setHasSearchResult(false);
    }
  }, [searchTerm]);

  return (
    <SearchBar
      className={styles.searchForm}
      name="video-search"
      value={searchTerm}
      onChange={setSearchTerm}
      onSearch={() => {
        setHasSearchResult(true);
        setIsMenuDismissed(true);
      }}
    >
      {isMenuVisible && (
        <div className={styles.listContainer} data-testid="learning-centre-matches">
          {Object.values(filteredByKeyWordLists).map((video, index) => {
            const title = video.title;
            const lowerSearchTerm = searchTerm.toLowerCase();
            const indexOfMatch = title.toLowerCase().indexOf(lowerSearchTerm);

            if (indexOfMatch !== -1) {
              const beforeMatch = title.substring(0, indexOfMatch);
              const match = title.substring(indexOfMatch, indexOfMatch + lowerSearchTerm.length);
              const afterMatch = title.substring(indexOfMatch + lowerSearchTerm.length);

              return (
                <div
                  key={index}
                  className={styles.selectOption}
                  onClick={() => {
                    getSelectedVideo(video);
                    setIsMenuDismissed(true);
                  }}
                >
                  {beforeMatch}
                  <strong>{match}</strong>
                  {afterMatch}
                </div>
              );
            } else {
              return (
                <div
                  key={index}
                  className={styles.selectOption}
                  onClick={() => {
                    getSelectedVideo(video);
                    setIsMenuDismissed(true);
                  }}
                >
                  {title}
                </div>
              );
            }
          })}
        </div>
      )}
    </SearchBar>
  );
}
